export default __webpack_public_path__ + "static/media/zhumka2.29cf6029.jpg";